import { useQuery } from "@tanstack/react-query";
import { sortBy } from "lodash";
import CoreAPIClient from "../../../api/core/CoreAPIClient";
import CoreAPIClientError from "../../../api/core/CoreAPIClientError";
import { useCoreAPIClient } from "../../../api/core/CoreAPIClientProvider";
import useGatekeeper from "../../../hooks/useGatekeeper";
import { UseQueryOptions, UseQueryResult } from "../../../lib/react-query";
import copyText from "../copyText";
import queryKeys from "./queryKeys";

type BillingRuleEntity = Awaited<
  ReturnType<CoreAPIClient["getBillingRulesByTenantID"]>
>[number];

export function useGetBillingRulesByTenantID(
  tenantID: string,
  options?: UseQueryOptions<BillingRuleEntity[], CoreAPIClientError>
): UseQueryResult<BillingRuleEntity[], CoreAPIClientError> {
  const client = useCoreAPIClient();
  const gatekeeper = useGatekeeper();

  const enabled =
    options?.enabled !== undefined
      ? options.enabled && gatekeeper.canReadBillingRules
      : gatekeeper.canReadBillingRules;

  return useQuery({
    queryKey: queryKeys.billingRules(tenantID),
    queryFn: async () => {
      const rules = await client.getBillingRulesByTenantID(tenantID);

      // Sort by priority so the dnd works properly.
      // Otherwise the rows will look out of order on first attempt to sort.
      return sortBy(rules, "priority");
    },
    meta: { errorMessage: copyText.errorLoadingBillingRulesMessage },
    enabled,
    ...options,
  });
}
